module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.fa277232.woff";